<template>
  <v-dialog v-model="showModal" scrollable width="450px">
    <v-card v-if="factoring" class="cardStyle" elevation="12">
      <v-card-title class="justify-center titleCard" style="text-align: center">
        <span>{{ $t('Bypay Summary') }}</span>
      </v-card-title>
      <div style="height: 90%;overflow-y: scroll;">
        <v-card-text style="align-self: center">
          {{ $t('ByppaySummary.The Bypay has been approved for everyone:') }}
        </v-card-text>
        <v-card-text id="certificate" ref="document">
          <div ref="content" class="container">
            <div class="row">
              <div class="col">
                <strong>{{ $t('Date') }}:</strong>
              </div>
              <div class="col">
                {{ date }}
              </div>
            </div>
            <div class="row">
              <div class="col">
                <strong>{{ $t('Certificate number') }}:</strong>
              </div>
              <div class="col">
                {{ certificateNumber }}
              </div>
            </div>
            <div class="row">
              <div class="col">
                <strong>{{ $t('Debtor (A)') }}:</strong>
              </div>
              <div class="col">
                {{ getName(payer) }}
              </div>
            </div>
            <div class="row">
              <div class="col">
                <strong>{{ $t('Creditor (B)') }}:</strong>
              </div>
              <div class="col">
                {{ getName(middle) }}
              </div>
            </div>
            <div class="row">
              <div class="col">
                <strong>{{ $t('Beneficiary (C)') }}:</strong>
              </div>
              <div class="col">
                {{ getName(receiver) }}
              </div>
            </div>

            <div class="row">
              <div class="col">
                <strong>{{ $t('Compensated ammount') }}:</strong>
              </div>
              <div class="col">
                <div>
                  {{ compensated }}
                </div>
                <div>
                  ({{ $t('Quantity that A deduces from his debt with B through a payment to C') }})
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <strong>{{ $t('Payment from debtor (A) to beneficiary (C)') }}:</strong>
              </div>
              <div class="col">
                <div>
                  {{ payment }}
                </div>
                <div>
                  {{ $t('To the following account') }}: {{ account }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <strong>{{ $t('Manifested agreement') }}:</strong>
              </div>
            </div>
            <div class="row">
              <div class="col">
                {{ $t('certificate.middle', {amount: factoring.formulaCalc.ABini, invoiceNumberAB: invoiceNumberAB}) }}
                <a :href="invoiceLinkAB" target="_blank">link</a>
                {{ $t('certificate.middleP2', {amount: factoring.formulaCalc.ABini, invoiceNumberAB: invoiceNumberAB}) }}
                {{ $t('certificate.middle2') }}
                <a :href="invoiceLinkCompensated" target="_blank">link</a>
              </div>
            </div>
            <div class="row">
              <div class="col">
                {{ $t('certificate.receiver', {amount: factoring.formulaCalc.ACclc, invoiceNumberBC: invoiceNumberBC }) }}
                <a :href="invoiceLinkBC" target="_blank">link</a>
                {{ $t('certificate.receiver2') }}2
                <a :href="invoiceLinkCleared" target="_blank">link</a>.
              </div>
            </div>
            <div class="row">
              <div class="col">
                {{ $t('certificate.payer', {amount: factoring.formulaCalc.earnA.toFixed(2)}) }}
              </div>
            </div>
            <div class="row">
              <div class="col">
                {{ $t('This certificate reflects the agreement executed by the three parties') }}
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-text>
          <span v-if="invoiceR" :id="'capture' + invoiceR.image.IdInvoice">
            <ShowInvoiceInformationImage v-if="factoring.formulaCalc.BCout.toString() === '0'" style="margin-top: 5px;" :invoice="invoiceR.invoice" :txt="$t('Bypaysummary.Compensated')" />
            <ShowInvoiceInformationImage v-else style="margin-top: 5px;" :invoice="invoiceR.invoice" :payer="invoiceR.invoice.payerCif" :amount="factoring.formulaCalc.BCout" />
          </span>
          <span v-if="invoiceP" :id="'capture' + invoiceP.image.IdInvoice">
            <ShowInvoiceInformationImage v-if="factoring.formulaCalc.ABout.toString() === '0'" :invoice="invoiceP.invoice" :txt="$t('Bypaysummary.Compensated')" />
            <ShowInvoiceInformationImage v-else :invoice="invoiceP.invoice" :amount="factoring.formulaCalc.ABout" :receiver-cif="invoiceP.invoice.receiverCif" :payer="invoiceP.invoice.payerCif" />
          </span>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row v-if="factoringModel" justify="center">
              <!-- Buttons to pay to -->
              <v-col v-if="factoringModel.iAmThePayer() && factoringModel.payerToReceiverUnpayed() && factoringModel.payerHadToPayReceiver()" cols="12">
                <div v-if="marketItem === null">
                  {{ paymentStatusLine1 }}
                  <PaymentComponent v-if="factoringModel.acceptedPayments().includes(Constants.FACTORING_PAYMENT_METHODS.OPEN_BANKING) && userReceiverModel.user.stripePublickey !== ''" :amount="payment" :user="userReceiverModel.user" :factoring="factoring" @success="onSuccess" @cancel="onCancel" />
                  <PaymentComponent v-if="factoringModel.acceptedPayments().includes(Constants.FACTORING_PAYMENT_METHODS.OPEN_BANKING) && userReceiverModel.user.stripePublickey !== ''" :amount="payment" :user="userReceiverModel.user" :factoring="factoring" @success="onSuccess" @cancel="onCancel" />
                  <v-btn v-if="factoringModel.acceptedPayments().includes(Constants.FACTORING_PAYMENT_METHODS.OUTSIDE_PLATFORM)" style="margin: 10px 0" class="paymentInformation" @click="payerPaymentToReceiverUpdate(Constants.FACTORING.STATUS_PAYED)">
                    {{ $t('I payed outside of platform') }}
                  </v-btn>
                  <v-btn v-if="factoringModel.acceptedPayments().includes(Constants.FACTORING_PAYMENT_METHODS.CRYPTO) && userReceiverModel.user.walletAddress !== ''" style="margin: 10px 0" class="paymentInformation" @click="payCrypto(userReceiverModel.user.walletAddress, payment, Constants.FACTORING.STATUS_ACCEPTED)">
                    {{ $t('Pay with crypto') }}
                  </v-btn>
                </div>
                <div v-else>
                  <span> Byppay pujat al market. Pagar {{ this.marketItem.amount }} per compensar els collaterals. <br> Pagar amb: <br></span>
                  <v-card>
                    <v-tabs
                      v-model="tab"
                      background-color="primary"
                      fixed-tabs
                      dark
                    >
                      <v-tab
                        v-for="item in items"
                        :key="item.tab"
                      >
                        {{ item.tab }}
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                      <v-tab-item
                        key="CRYPTO"
                      >
                        <v-card flat>
                          <v-card-text>
                            Pagament amb crypto a traves de metamask
                            <v-btn style="margin: 10px 0" class="paymentInformation" @click="payWithCrypto(marketItem)">
                              {{ $t('Pay with crypto') }}
                            </v-btn>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>

                      <v-tab-item
                        key="STRIPE"
                      >
                        <v-card flat>
                          <v-card-text>
                            <CarouselPayments :market-item="marketItem" :collaterals="collaterals" :factoring="factoring" />
                          </v-card-text>
                        </v-card>
                      </v-tab-item>

                      <v-tab-item
                        key="BANC"
                      >
                        <v-card flat>
                          <v-card-text>
                            <v-btn v-if="factoringModel.acceptedPayments().includes(Constants.FACTORING_PAYMENT_METHODS.OUTSIDE_PLATFORM)" style="margin: 10px 0" class="paymentInformation" @click="payerPaymentToReceiverUpdate(Constants.FACTORING.STATUS_PAYED)">
                              {{ $t('I payed outside of platform') }}
                            </v-btn>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card>
                </div>
              </v-col>
              <v-col v-if="factoringModel.iAmTheReceiver() && factoringModel.receiverFromPayerPayed() && factoringModel.payerHadToPayReceiver()" cols="12">
                {{ paymentStatusLine1 }}
                <v-btn class="paymentInformation" @click="payerPaymentToReceiverUpdate(Constants.FACTORING.STATUS_ACCEPTED)">
                  <!-- I'm C and not received from A -->
                  {{ $t('Payment received') }}
                </v-btn>
              </v-col>
              <v-col v-if="factoringModel.iAmTheReceiver() && factoringModel.receiverFromMiddlePayed() && factoringModel.middleHadToPayReceiver()" cols="12">
                {{ paymentStatusLine2 }}
                <v-btn class="paymentInformation" @click="middlePaymentToReceiverUpdate(Constants.FACTORING.STATUS_ACCEPTED)">
                  <!-- I'm C and not received from B -->
                  {{ $t('Payment received') }}
                </v-btn>
              </v-col>
              <v-col v-if="factoringModel.iAmTheMiddle() && factoringModel.middleFromPayerPayed() && factoringModel.payerHadToPayMiddle()" cols="12">
                {{ paymentStatusLine2 }}
                <v-btn class="paymentInformation" @click="payerPaymentToMiddleUpdate(Constants.FACTORING.STATUS_ACCEPTED)">
                  <!-- I'm B and not received from A -->
                  {{ $t('Payment received') }}
                </v-btn>
              </v-col>
              <v-col v-if="factoringModel.iAmThePayer()">
                <!-- A -->
                <div v-if="((factoringModel.receiverFromPayerPayed() || factoringModel.receiverFromPayerAccepted()) && factoringModel.payerHadToPayReceiver())" cols="12">
                  {{ paymentStatusLine1 }}
                </div>
                <div v-if="((factoringModel.middleFromPayerPayed() || factoringModel.middleFromPayerAccepted()) && factoringModel.payerHadToPayMiddle())" cols="12">
                  {{ paymentStatusLine2 }}
                </div>
              </v-col>
              <v-col v-if="factoringModel.iAmTheMiddle()">
                <!-- B -->
                <div v-if="((factoringModel.receiverFromMiddlePayed() || factoringModel.receiverFromMiddleAccepted()) && factoringModel.middleHadToPayReceiver())" cols="12">
                  {{ paymentStatusLine1 }}
                </div>
                <div v-if="((factoringModel.payerToMiddleUnpayed() || factoringModel.middleFromPayerAccepted()) && factoringModel.payerHadToPayMiddle())" cols="12">
                  {{ paymentStatusLine2 }}
                </div>

                <div v-if="factoringModel.middleHadToPayPlatform()" cols="12">
                  {{ paymentStatusLine1 }}
                </div>
                <div v-if="factoringModel.middleToPlatformUnpayed()" cols="12">
                  <PaymentComponent v-if="factoringModel.acceptedPayments().includes(Constants.FACTORING_PAYMENT_METHODS.OPEN_BANKING) && this.platformAccounts.stripe && this.platformAccounts.stripe.public_key !== ''" :amount="paymentToPlatform" :user="{stripePublickey: this.platformAccounts.stripe.public_key, _id: 'platform' }" @success="onSuccess()" @cancel="onCancel" />
                  <v-btn v-if="factoringModel.acceptedPayments().includes(Constants.FACTORING_PAYMENT_METHODS.OUTSIDE_PLATFORM)" style="margin: 10px 0" class="paymentInformation" @click="middlePaymentToPlatformUpdate(Constants.FACTORING.STATUS_PAYED)">
                    {{ $t('I payed outside of platform') }}
                  </v-btn>
                  <v-btn v-if="factoringModel.acceptedPayments().includes(Constants.FACTORING_PAYMENT_METHODS.CRYPTO) && this.platformAccounts.walletAddress !== ''" style="margin: 10px 0" class="paymentInformation" @click="payCrypto(this.platformAccounts.walletAddress, middlePaymentToPlatformUpdate, Constants.FACTORING.STATUS_ACCEPTED)">
                    {{ $t('Pay with crypto') }}
                  </v-btn>
                </div>
                <div cols="12">
                  {{ paymentStatusLine2 }}
                </div>
              </v-col>
              <v-col v-if="factoringModel.iAmTheReceiver()">
                <!-- C -->
                <div v-if="((factoringModel.payerToReceiverUnpayed() || factoringModel.receiverFromPayerAccepted()) && factoringModel.payerHadToPayReceiver())" cols="12">
                  {{ paymentStatusLine1 }}
                </div>
                <div v-if="((factoringModel.middleToReceiverUnpayed() || factoringModel.receiverFromMiddleAccepted()) && factoringModel.middleHadToPayReceiver())" cols="12">
                  {{ paymentStatusLine2 }}
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
        <v-card-actions>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-btn class="btnYes" depressed x-large style="margin-bottom: 15px; width: 75%;font-size: 12px" @click="downloadCertificate()">
                    {{ $t('CERTIFICATE') }}
                  </v-btn>
                </v-row>
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-btn color="#00E5FF" dark depressed x-large style="margin-bottom: 15px; width: 75%;font-size: 12px" @click="downloadInvoicePayer()">
                    {{ $t('DOWNLOAD') }}<br>
                    {{ $t('ByppaySummary.PAYER INVOICE') }}
                  </v-btn>
                </v-row>
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-btn class="btn-primary" dark depressed x-large style="margin-bottom: 15px; width: 75%;font-size: 12px" @click="downloadInvoiceReceiver()">
                    {{ $t('DOWNLOAD') }}<br>
                    {{ $t('ByppaySummary.RECEIVER INVOICE') }}
                  </v-btn>
                </v-row>
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-btn class="btnNo" depressed x-large @click="closeModal()">
                    {{ $t('Close') }}
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ShowInvoiceInformationImage from "./ShowInvoiceInformationImage";
import ApiRepository from "../repositories/ApiRepository";
import SmartRepository from "../repositories/SmartRepository";
import {Factoring} from "../models/factoring";
import {User} from "../models/user";
import Constants from "../../constants";
import moment from "moment";
import PaymentComponent from "../components/Payment";
import html2pdf from 'html2pdf.js';
import html2canvas from "html2canvas";
import Config from "../../../Server/config/config";
import Hash from "object-hash";
import CarouselPayments from "components/CarouselPayments";
const IERC20 = require("../../public/IERC20.json");

export default {
    name: "BypaySummary",
    components: { ShowInvoiceInformationImage, PaymentComponent, CarouselPayments },
    data () {
        return {
            platformAccounts: null,
            aAcceptReceiveBytos: false,
            config: Config,
            tab: null,
            items: [
                { tab: 'CRYPTO', content: 'Tab 1 Content' },
                { tab: 'STRIPE', content: 'Tab 2 Content' },
                { tab: 'BANC', content: 'Tab 3 Content' },
            ],
            collaterals: [],
            marketItem: null,
            invoiceP: null,
            invoiceR: null,
            factoringModel: null,
            userPayerModel: null,
            userMiddleModel: null,
            userReceiverModel: null,
            showModal: false,
            factoring: null,
            invoices: [],
            Constants: Constants,
            paymentStatusLine1: "",
            paymentStatusLine2: "",
            date: "",
            certificateNumber: "",
            payer: null,
            middle: null,
            receiver: null,
            compensated: 0,
            payment: 0,
            paymentNoByto: 0,
            paymentByto: 0,
            paymentToPlatform: 0,
            paymentMiddleToReceiver: 0,
            account: "",
            invoiceNumberAB: "",
            invoiceLinkAB: "",
            invoiceLinkCompensated: "",
            invoiceNumberBC: "",
            invoiceLinkBC: "",
            invoiceLinkCleared: "",
            bonus: 0
        };
    },
    created () { },
    methods: {
        onSuccess () {
            if (this.factoringModel.iAmThePayer()) {
                this.payerPaymentToReceiverUpdate(Constants.FACTORING.STATUS_ACCEPTED);
            } else if (this.factoringModel.iAmTheMiddle()) {
                this.middlePaymentToReceiverUpdate(Constants.FACTORING.STATUS_ACCEPTED);
            }
        },
        onCancel () {
            console.log("cancel");
        },
        getAllUrlParams (url) {

            // get query string from url (optional) or window
            let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

            // we'll store the parameters here
            const obj = {};

            // if query string exists
            if (queryString) {

                // stuff after # is not part of query string, so get rid of it
                queryString = queryString.split('#')[0];

                // split our query string into its component parts
                const arr = queryString.split('&');

                for (const element of arr) {
                    // separate the keys and the values
                    const a = element.split('=');

                    // set parameter name and value (use 'true' if empty)
                    let paramName = a[0];
                    let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

                    // (optional) keep case consistent
                    paramName = paramName.toLowerCase();
                    if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

                    // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                    if (paramName.match(/\[(\d+)?\]$/)) {

                        // create key if it doesn't exist
                        const key = paramName.replace(/\[(\d+)?\]/, '');
                        if (!obj[key]) obj[key] = [];

                        // if it's an indexed array e.g. colors[2]
                        if (paramName.match(/\[\d+\]$/)) {
                            // get the index value and add the entry at the appropriate position
                            const index = /\[(\d+)\]/.exec(paramName)[1];
                            obj[key][index] = paramValue;
                        } else {
                            // otherwise add the value to the end of the array
                            obj[key].push(paramValue);
                        }
                    } else if (!obj[paramName]) {
                        // if it doesn't exist, create property
                        obj[paramName] = paramValue;
                    } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                        // if property does exist and it's a string, convert it to an array
                        obj[paramName] = [obj[paramName]];
                        obj[paramName].push(paramValue);
                    } else {
                        // otherwise add the property
                        obj[paramName].push(paramValue);
                    }

                }
            }

            return obj;
        },
        show (invoiceA, invoiceB, factoring) {
            this.invoiceA = invoiceA;
            this.invoiceB = invoiceB;
            ApiRepository.getPlatformPublicAccounts().then((accounts) => {
                this.platformAccounts = accounts.data.accounts;
            });
            ApiRepository.getFactoringById(factoring._id)
                .then(async (res) => {
                    if (res.data && res.data.factoring) {
                        this.factoring = res.data.factoring;

                        let facUser = this.$user;
                        const urlParams = this.getAllUrlParams(window.location.href);
                        if (facUser == null && typeof urlParams.me !== 'undefined') {
                            facUser = await ApiRepository.getUserById(urlParams.me);
                            facUser = facUser.data.user;
                        }
                        this.factoringModel = new Factoring(this.factoring, facUser, this.$parameters);

                        console.log(typeof res.data.factoring.wantsBytos.payer);
                        console.log(res.data.factoring.wantsBytos.payer);

                        this.userPayerModel = new User(this.factoring.payer);
                        this.userMiddleModel = new User(this.factoring.middle);
                        this.userReceiverModel = new User(this.factoring.receiver);
                        const lines = this.factoringModel.paymentInformation();
                        this.paymentStatusLine1 = lines.line1;
                        this.paymentStatusLine2 = lines.line2;
                        this.creatingResultInvoices();
                        // -- //
                        this.factoring = res.data.factoring;
                        this.date = moment(this.factoring.created).format("DD/MM/YYYY ");
                        if (this.factoring.hash.length > 0) this.certificateNumber = this.factoring.hash[0];
                        this.payer = new User(this.factoring.payer);
                        this.middle = new User(this.factoring.middle);
                        this.receiver = new User(this.factoring.receiver);
                        this.compensated = this.factoring.compensation;
                        if (this.factoring.invoice_receiver.amount < this.factoring.invoice_payer.amount) this.compensated = this.factoring.invoice_receiver.amount;
                        else this.compensated = this.factoring.invoice_payer.amount;
                        this.paymentNoByto = this.factoring.formulaCalc.ACclc;
                        this.paymentByto = this.factoring.formulaCalc.ACclc + this.factoring.formulaCalc.earnA;
                        this.getPaymentOfByppay();
                        this.paymentToPlatform = this.factoring.formulaCalc.earnP;
                        this.account = this.factoring.invoice_receiver.accountNumber;
                        this.invoiceNumberAB = this.factoring.invoice_payer.number;
                        this.invoiceNumberBC = this.factoring.invoice_receiver.number;
                        this.invoiceLinkAB = "/invoice/" + this.factoring.invoice_payer._id;
                        this.invoiceLinkBC = "/invoice/" + this.factoring.invoice_receiver._id;
                        this.invoiceLinkCompensated = Constants.BLOCKCHAIN_URL + this.factoring.hash[0];
                        this.invoiceLinkCleared = Constants.BLOCKCHAIN_URL + this.factoring.hash[0];
                        this.bonus = this.factoring.platformComission;
                        await this.getMarketInformation();
                    }
                })
                .catch((err) => {
                    console.log(err);
                });

        },
        getPaymentOfByppay () {
            const tmpFact = this.factoringModel;
            this.factoringModel = null;
            if (this.aAcceptReceiveBytos) {
                this.payment = this.paymentByto;
            } else {
                this.payment = this.paymentNoByto;
            }
            this.$nextTick(() => {
                this.factoringModel = tmpFact;
            });
        },
        creatingResultInvoices () {
            this.invoices = [];
            this.$root.$emit('start-loading');
            ApiRepository.creatingResultInvoices(this.factoring._id)
                .then((res) => {
                    if (res.data) {
                        this.invoiceP = res.data.invoicePayer;
                        this.invoiceR = res.data.invoiceReceiver;
                        this.showModal = true;
                        if (this.invoiceR && this.factoring.formulaCalc.BCout !== 0) {
                            this.paymentMiddleToReceiver = this.factoring.formulaCalc.BCout;
                        } else if (this.invoiceP && this.factoring.formulaCalc.ABout !== 0) {
                            this.paymentMiddleToReceiver = this.factoring.formulaCalc.ABout;
                        }
                    }
                })
                .catch((err) => {
                    console.log("ERROR: " + err);
                })
                .finally(() => {
                    this.$root.$emit('stop-loading');
                });

        },
        closeModal () {
            this.factoring = null;
            this.invoices = [];
            this.showModal = false;
        },
        getName (user) {
            if (user) {
                return user.getName();
            }
            return "";
        },
        goBack () {
            this.$router.push({name: 'home', replace: true}).catch((e) => { console.log(e); });
        },
        isOpen () {
            return this.showModal;
        },
        openNewView () {
            this.screenshot();
            //this.$router.push({name: 'ComparativeInvoice', params: {id: this.factoring._id}, replace: true});
        },
        openCertificate () {
            const sel = document.querySelector("#certificate");
            const initialColor = sel.style.color;
            sel.style.color = "black";
            this.downloading = true;
            html2canvas(sel, {}).then(canvas => {
                const a = document.createElement("a");
                a.setAttribute('href', canvas.toDataURL('image/png'));
                a.setAttribute('download', 'Test.png');
                a.click();
            });
            sel.style.color = initialColor;
        },

        payCrypto (wallet, amount, done, newStatus) {
            SmartRepository.transaction(Constants.contractByto, "transfer", [wallet, SmartRepository.parseEther(amount)]).then(() => {
                done(newStatus);
            }).catch((err) => {
                console.log("ERROR: " + err);
                this.$root.$emit('show-snackbar', {message: this.$t('Error changing the payment status'), color: 'error'});
            });
        },

        payerPaymentToReceiverUpdate (newStatus) { // tag
            const urlParams = this.getAllUrlParams(window.location.href);
            ApiRepository.payerPaymentToReceiverUpdate(this.factoring._id, newStatus, urlParams.me, this.aAcceptReceiveBytos)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Success changing the payment status')});
                    this.factoring.payerPaymentToReceiver = newStatus;
                })
                .catch((err) => {
                    console.log("ERROR: " + err);
                    this.$root.$emit('show-snackbar', {message: this.$t('Error changing the payment status'), color: 'error'});
                });

        },

        payerPaymentToPlatformUpdate (newStatus) { // tag
            const urlParams = this.getAllUrlParams(window.location.href);
            ApiRepository.payerPaymentToPlatformUpdate(this.factoring._id, newStatus, urlParams.me, this.aAcceptReceiveBytos)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Success changing the payment status')});
                    this.factoring.payerPaymentToPlatform = newStatus;
                })
                .catch((err) => {
                    console.log("ERROR: " + err);
                    this.$root.$emit('show-snackbar', {message: this.$t('Error changing the payment status'), color: 'error'});
                });

        },
        middlePaymentToReceiverUpdate (newStatus) {
            ApiRepository.middlePaymentToReceiverUpdate(this.factoring._id, newStatus)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Success changing the payment status')});
                    this.factoring.middlePaymentToReceiver = newStatus;
                })
                .catch((err) => {
                    console.log("ERROR: " + err);
                    this.$root.$emit('show-snackbar', {message: this.$t('Error changing the payment status'), color: 'error'});
                });
        },
        middlePaymentToPlatformUpdate (newStatus) {
            ApiRepository.middlePaymentToPlatformUpdate(this.factoring._id, newStatus)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Success changing the payment status')});
                    this.factoring.middlePaymentToPlatform = newStatus;
                })
                .catch((err) => {
                    console.log("ERROR: " + err);
                    this.$root.$emit('show-snackbar', {message: this.$t('Error changing the payment status'), color: 'error'});
                });
        },
        payerPaymentToMiddleUpdate (newStatus) {
            ApiRepository.payerPaymentToMiddleUpdate(this.factoring._id, newStatus)
                .then(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Success changing the payment status')});
                    this.factoring.payerPaymentToMiddle = newStatus;
                })
                .catch((err) => {
                    console.log("ERROR: " + err);
                    this.$root.$emit('show-snackbar', {message: this.$t('Error changing the payment status'), color: 'error'});
                });
        },
        downloadInvoicePayer () {
            const sel = "#capture" + this.invoiceP.image.IdInvoice;
            this.downloading = true;
            html2canvas(document.querySelector(sel), {}).then(canvas => {
                const a = document.createElement("a");
                a.setAttribute('href', canvas.toDataURL('image/png'));
                a.setAttribute('download', 'InvoicePayer.png');
                a.click();
            });
        },
        downloadInvoiceReceiver () {
            const sel = "#capture" + this.invoiceR.image.IdInvoice;
            this.downloading = true;
            html2canvas(document.querySelector(sel), {}).then(canvas => {
                const a = document.createElement("a");
                a.setAttribute('href', canvas.toDataURL('image/png'));
                a.setAttribute('download', 'InvoiceReceiver.png');
                a.click();
            });
        },
        downloadCertificate () {
            html2pdf(this.$refs.document, {
                margin: 1,
                filename: 'invoice.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { dpi: 192, letterRendering: true },
                jsPDF: { unit: 'in', format: 'letter' }
            });
        },
        getMarketInformation () {
            ApiRepository.getMarketItem(this.factoring._id)
                .then((res) => {
                    this.marketItem = res.data.item;
                    ApiRepository.getCollateralsNotPayedByFactoringId(this.factoring._id)
                        .then((res) => {
                            this.collaterals = res.data.collaterals;
                        })
                        .catch((e) => {
                            this.$root.$emit('show-snackbar', {message: this.$t('Error get collaterals'), color: 'error'});
                        });
                })
                .catch((e) => {
                    console.log(e);
                    // this.$root.$emit('show-snackbar', {message: this.$t('Error get market item'), color: 'error'});
                });
        },
        payWithCrypto (item) {
            SmartRepository.call(Constants.contractByto, "allowance", [SmartRepository.getMyAddress(), Constants.contractMarketplace.address])
                .then((res) => {
                    if (res.toString() === '0') {
                        const BN = SmartRepository.getBN();
                        const maxNumber = (BN.from(2)).pow(BN.from(256)).sub(BN.from(1));
                        SmartRepository.transaction(Constants.contractByto, "increaseAllowance", [Constants.contractMarketplace.address, maxNumber])
                            .then(() => {
                                this.payCollateral(item);
                            }).catch((e) => {
                                let message = e.toString();
                                if (e.message) {
                                    message = e.message;
                                }
                                this.$root.$emit('show-snackbar', {message: message, color: "error"});
                            });
                    } else {
                        this.payCollateral(item);
                    }
                });
        },
        payCollateral (item) {
            const mySTR = item.factoring.toString();
            const hash = '0x' + Hash.sha1(mySTR);
            SmartRepository.transaction(Constants.contractMarketplace, "payInvoice", [hash])
                .then((res) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Collateral payed'), color: 'success'});
                    this.payerPaymentToReceiverUpdate(Constants.FACTORING.STATUS_ACCEPTED);
                    ApiRepository.closeMarketItem(mySTR).then((res) => {
                        this.fetch();
                    })
                        .catch((e) => {
                            console.log(e);
                        });
                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error: pay collateral'), color: 'error'});
                });
        },
    },
};
</script>

<style scoped>
  .paymentInformation{
    width: 100%;
  }
</style>
